import React, { ReactNode } from 'react'

import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd'
import { ButtonHTMLType, ButtonShape } from 'antd/es/button'

import Icon from './Icon'

import './ButtonStyles.less'

type IconPosition = 'left' | 'right'

export interface ButtonProps extends AntButtonProps {
  disabled?: boolean
  icon?: string | undefined | any
  customIcon?: ReactNode
  iconPosition?: IconPosition | undefined
  shape?: ButtonShape
  size?: any
  onClick?: React.MouseEventHandler<HTMLElement>
  onMouseUp?: React.MouseEventHandler<HTMLElement>
  className?: string
  htmlType?: ButtonHTMLType
  loading?: boolean
  children?: ReactNode
}

const getButtonContentBasedOnIconState = (
  icon: string | undefined,
  iconPosition: IconPosition | undefined,
  children: ReactNode,
  customIcon: ReactNode,
): ReactNode => {
  if (customIcon) {
    return (
      <div className="button__custom_icon">
        <div className="ml-8 mr-8">{customIcon}</div>
        {children}
      </div>
    )
  }
  if (icon === undefined) {
    return children
  } else {
    if (iconPosition === undefined || iconPosition === 'left') {
      return (
        <>
          <Icon type={icon} className="pr-8" fontAwesome />
          {children}
        </>
      )
    } else {
      return (
        <>
          {children}
          <Icon type={icon} className="pl-8" fontAwesome />
        </>
      )
    }
  }
}

class Button extends React.Component<ButtonProps> {
  static __ANT_BUTTON = true

  render() {
    const { icon, iconPosition, children, customIcon, ...props } = this.props
    return (
      <AntButton {...props}>{getButtonContentBasedOnIconState(icon, iconPosition, children, customIcon)}</AntButton>
    )
  }
}

export default Button
